import { isEmpty } from 'lodash';

import { BaseSubscriptionService } from './BaseSubscription.service';
import { SymbolSubscriptionRequestType } from './types';

export abstract class BaseSymbolSubscriptionService<T extends SymbolSubscriptionRequestType>
  extends BaseSubscriptionService<T> {
  // eslint-disable-next-line no-useless-constructor
  protected constructor(token: string) {
    super(token);
  }

  public subscribe(symbol: string): void {
    const requestBySymbol = this.getRequestBySymbol(symbol);

    if (requestBySymbol) { // This symbol already in the subscription request list!
      return;
    }

    const request = {
      symbols: [ symbol ],
      ...this.getDefaultRequestParams(),
    } as T;
    this.subscripitonRequests.push(request);
    this.gatewayService.sendRequest(request);
  }

  public subscribeList(symbols: string[]): void {
    if (isEmpty(this.subscripitonRequests)) {
      const request = {
        symbols,
        ...this.getDefaultRequestParams(),
      } as T;
      this.subscripitonRequests.push(request);
      this.gatewayService.sendRequest(request);
      return;
    }

    const notRequestedList = symbols.filter(item => !this.subscripitonRequests[0]?.symbols.includes(item)) || [];

    if (isEmpty(notRequestedList)) { // All symbols are already added to subscription request list!
      return;
    }

    this.subscripitonRequests[0].symbols = [ ...this.subscripitonRequests[0]?.symbols || [], ...notRequestedList ];// add symbols to releated list
    this.gatewayService.sendRequest({
      symbols: notRequestedList,
      ...this.getDefaultRequestParams(),
    });
  }

  public unsubscribe(symbol: string): void {
    if (isEmpty(this.subscripitonRequests)) { // The subscription list is already empty!
      return;
    }

    if (!this.subscripitonRequests[0].symbols.includes(symbol)) { // There is no request in the list by the given symbol
      return;
    }

    this.subscripitonRequests[0].symbols = this.subscripitonRequests[0].symbols.filter(item => item !== symbol);
    this.gatewayService.sendRequest({
      ...this.getDefaultRequestParams(),
      symbols: [ symbol ],
      messageType: this.getUnsubscriptionRequestType(),
    });
  }

  public unsubscribeList(symbols: string[]): void {
    if (isEmpty(this.subscripitonRequests)) { // The subscription list is already empty!
      return;
    }

    const subscripitonRequest = this.subscripitonRequests[0];
    const requestedList = symbols.filter(item => subscripitonRequest?.symbols.includes(item)) || [];

    if (isEmpty(requestedList)) { // The symbols are not in the subscription request list!
      return;
    }

    subscripitonRequest.symbols = subscripitonRequest.symbols.filter(item => !requestedList.includes(item));// remove given symbols from the list
    this.gatewayService.sendRequest({
      ...this.getDefaultRequestParams(),
      symbols: requestedList,
      messageType: this.getUnsubscriptionRequestType(),
    });
  }

  protected getRequestBySymbol(symbol: string): SymbolSubscriptionRequestType | undefined {
    return this.subscripitonRequests.find(
      item => item.symbols.includes(symbol),
    );
  }
}
